/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {NB_AUTH_OPTIONS} from '@nebular/auth/auth.options';
import {getDeepFromObject} from '@nebular/auth/helpers';
import {TranslateService} from '@ngx-translate/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {NbAuthService} from '@nebular/auth/services/auth.service';
import { ActionService } from '../../../../@core/data/action.service';
import { NbAuthJWTToken } from '@nebular/auth';

@Component({
  selector: 'ngx-authenticated',
  templateUrl: './authenticated.component.html',
})
export class NgxAuthenticatedComponent implements OnInit {
  redirectDelay = 0;
  showMessages: any = {};
  provider = '';
  currentLang = 'es';

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted = false;
  logo = '';

  information: boolean = false;
  loading: boolean = true;

  constructor(
    private http: HttpClient,
    protected router: Router,
    private actionService: ActionService,
    protected service: NbAuthService,
    protected translate: TranslateService,
    @Inject(NB_AUTH_OPTIONS) protected config = {},
  ) {
    try {
      this.redirectDelay = this.getConfigValue('forms.login.redirectDelay');
      this.showMessages = this.getConfigValue('forms.login.showMessages');
      this.provider = this.getConfigValue('forms.login.provider');
      this.translate.onLangChange.subscribe((event: any) => {
        this.currentLang = event.lang;
      });
      const headers: HttpHeaders = new HttpHeaders({
        'Content-Type': 'application/json',
      });
      const options = {headers: headers};
      this.http
        .get('https://server.sinecta.com/api/v1/domains', options)
        .subscribe(
          (result: any) => {
            const full = window.location.host;
            if(full) {
              const parts = full.split('.');
              const sub = parts[0];
              let domain = `${parts[0]}.${parts[1]}`;
              if (domain === 'app.sinecta') { // app.sinecta.com
                return this.logo = 'https://sinecta.ana-ia.com/assets/images/aura_gds_white.png';
              }
  
              if (domain === 'clientes.sinecta' || sub == 'localhost:4200') { // app.sinecta.com
                return this.logo = '/assets/images/clientes/Sinecta_Logotipo-2-03.png';
                // return this.logo = 'https://server.sinecta.com/assets/images/clientes/Sinecta_Logotipo-2-03.png';
              }
            } else {
              return this.logo = 'https://server.sinecta.com/assets/images/domains/aura_gds_white.png';
            }
          });
    } catch (error) {
      console.log(error);
    }
  }

  ngOnInit(): void {
    this.changeLanguage('es');
    if ( localStorage.getItem('projects') ) {
      this.information = true;
      this.loading = false;
    }
  }

  changeLanguage(lang: string): void {
    this.translate.use(lang);
  }

  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/');
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.config, key, null);
  }
}
